import { getUKDirectDebitResponseSchema } from '@/api/UK/directDebit/schemas';
import { apiRequest } from '@/api/utils/api';

export const getDirectDebit = () =>
  apiRequest({
    url: '/uk/direct-debit',
    method: 'GET',
    schema: getUKDirectDebitResponseSchema,
  });
